//#region IMPORTS
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { ToastProvider } from 'react-toast-notifications';
import { Row } from 'react-bootstrap';
import language from '../../config/es';
//redux
import {
  findAll,
  saveEntity,
  deleteEntity,
  countPageByFilter,
} from '../../redux/collectingEntity.duck';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import { findCountries } from '../../redux/society.duck';
import { es_vacio, es_entero } from '../../config/validate';
//Session user
import SessionConfig from '../../config/session_config';
//Crud compartido
import {
  useCrudState,
  useCrudLifecycle,
} from '../../components/Crud/crudHooks';
import {
  buildEditColumn,
  renderDeleteAction,
  requireValues,
} from '../../components/Crud/crudHelpers';
import {
  RequiredFieldsAlert,
  SelectField,
  TextField,
} from '../../components/Crud/CrudFields';
import {
  CrudButtons,
  CrudDataTable,
  CrudPage,
} from '../../components/Crud/CrudLayout';
//#endregion IMPORTS

const CollectingEntity = () => {
  //#region VARIABLES
  const ref = useRef()
  const dispatch = useAppDispatch();
  let [country, setcountry] = useState({ value: 0, label: '', error: '' });
  const [pendingData, setPendingData] = useState(false);
  const {
    data,
    refreshState,
    updateState,
    viewNotification,
    handleSelectRow,
  } = useCrudState({
    id: 0,
    cEntities: [],
    societies: [],
    countries: [],
    name: { value: '', error: '' },
    code: { value: '', error: '' },
    replicationTime: { value: '0', error: '' },
    username: 'admin',
    errors: [],
    columns: [],
    selectedRows: [],
    enable: false,
    showDelete: false,
    auth: JSON.parse(sessionStorage.getItem('user')),
    error: '',
    page: 0,
    size: 10,
    totalRows: 0,
    response: '',
    showLoadingCountry: false,
  });
  data.countries = useSelector((store) => store.societyReducer.countries);
  data.error = useSelector(
    (store) => store.collectingEntityReducer.cEntityError
  );
  data.response = useSelector(
    (store) => store.collectingEntityReducer.cEntityAdd
  );
  data.cEntities = useSelector(
    (store) => store.collectingEntityReducer.cEntities
  );
  data.totalRows = useSelector(
    (store) => store.collectingEntityReducer.totalRows
  );

  //#region LIFECYCLE
  useEffect(() => {
    if (country.value !== 0) {
      setPendingData(true);
      void search();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country]);
  useEffect(() => {
    messageError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.error]);
  useEffect(() => {
    void responseAction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.response]);
  useCrudLifecycle(ref, data, () => {
    initTable();
    void loadCountries();
  });
  const messageError = () => {
    if (data.error !== '') {
      viewNotification(data.error.error, 'error');
    }
  };
  const responseAction = async () => {
    if (data.response !== '' && data.response !== null) {
      viewNotification(
        data.response.delete === true
          ? language.messages.msmDeleteDataSuccess
          : language.messages.msmRegister.replace('{0}', data.response.name),
        'success'
      );
      await search();
      clearError();
      clearForm();
      data.enable = true;
      setPendingData(false);
      refreshState();
    }
  };
  const loadCountries = async () => {
    await dispatch(findCountries(data.auth.id.user.userId));
    updateState(true, 'showLoadingCountry');
  };
  const search = async () => {
    updateState(false, 'enable');

    await loadCount();
    await loadCEntities();

    updateState(true, 'enable');
  };
  const reSearch = async () => {
    setPendingData(true);
    await search();
  };

  const loadCount = async () => {
    await dispatch(countPageByFilter(country.value));
  };
  const loadCEntities = async () => {
    let res = await dispatch(
      findAll(data.auth.id.user.username, country.value, data.page, data.size)
    );
    data.cEntities = res.data;

    setPendingData(false);
  };

  const initTable = () => {
    data.columns = [
      {
        name: language.messages.collectingEntity.Entity,
        sortable: false,
        wrap: true,
        width: '55%',
        cell: (row) => (
          <span>
            <div className=" text-uppercase small">{row.name}</div>
            <div className="badge bg-primary">
              {language.messages.collectingEntity.code}: {row.code}
            </div>
          </span>
        ),
      },
      {
        name: language.messages.collectingEntity.time,
        sortable: false,
        wrap: true,
        width: '20%',
        cell: (row) => (
          <span>
            <div className="text-dark text-uppercase">
              {row.replicationTime}
            </div>
          </span>
        ),
      },
      buildEditColumn(handleButtonEdit, {
        name: language.messages.lbEdit,
        width: '10px',
      }),
    ];
    updateState(data.columns, 'columns');
  };

  //#endregion LIFECYCLE

  //#region HANDLES
  const handlePerRowsChange = async (perPage, page) => {
    data.size = perPage;
    data.page = Number.parseInt(page) - 1;
    if (data.page < 0) {
      data.page = 0;
    }

    setPendingData(true);
    updateState(data.size, 'size');
    updateState(data.page, 'page');

    void search();
  };
  const handlePageChange = async (page) => {
    data.page = Number.parseInt(page) - 1;
    if (data.page < 0) {
      data.page = 0;
    }
    setPendingData(true);
    updateState(data.page, 'page');
    void search();
  };
  const handleDelete = () => {
    setPendingData(true);
    void disableData();
  };
  const handleButtonEdit = (row) => {
    setPendingData(false);
    data.enable = true;
    data.showLoadingCountry = true;
    clearError();
    data.id = row.id;
    data.name.value = row.name;
    data.code.value = row.code;
    data.replicationTime = { value: Number.parseInt(row.replicationTime), error: '' };
    initTable();
    refreshState();
  };

  const onChange = (event) => {
    // eslint-disable-next-line default-case
    switch (event.target.name) {
      case 'replicationTime':
        data.replicationTime.value = event.target.value;
        break;
      case 'name':
        data.name.value = event.target.value;
        data.name.error = '';
        break;
      case 'code':
        data.code.value = event.target.value;
        data.code.error = '';
        break;
    }
    refreshState();
  };

  //#endregion HANDLES

  //#region FUNCTIONS
  const updateSelect = async (value, id) => {
    setcountry(value);
  };
  const contextActions = renderDeleteAction(
    handleDelete,
    data.enable,
    language.messages.collectingEntity.down
  );

  const clearError = () => {
    data.errors = [];
    data.name.error = '';
    data.code.error = '';
    country.error = '';
    data.replicationTime.error = '';
  };
  const clearForm = () => {
    data.id = 0;
    data.name = { value: '', label: '' };
    data.code = { value: '', label: '' };
    data.replicationTime = { value: '0', error: '' };
    data.errors = [];
  };
  const validate = () => {
    clearError();
    requireValues(data, ['name', 'code']);
    if (es_vacio(country.label)) {
      data.errors.push('country.error');
      country.error = language.messages.warning_required_field;
    }
    if (!es_entero(data.replicationTime.value)) {
      data.errors.push('replicationTime.error');
      data.replicationTime.error = language.messages.error_numero;
    }
    refreshState();
  };
  const cleaningForm = () => {
    clearError();
    clearForm();
    refreshState();
    viewNotification(language.messages.successCleanData, 'success');
  };
  const reloadData = async () => {
    cleaningForm();
  };
  const disableData = async () => {
    if (data.selectedRows.length > 0) {
      data.enable = false;
      data.showDelete = false;

      await dispatch(
        deleteEntity(data.selectedRows, data.auth.id.user.username)
      );

      updateState(true, 'enable');
      updateState(true, 'showDelete');
      void reloadData();
    } else viewNotification(language.messages.msmEmptyDataDisabled, 'error');
  };
  const saveData = async () => {
    validate();

    if (data.errors.length === 0) {
      setPendingData(true);
      updateState(false, 'enable');
      let json = {
        id: data.id,
        name: data.name.value,
        code: data.code.value,
        replicationTime: data.replicationTime.value,
        country: country.value,
        userAdmin: data.auth.id.user.username,
      };

      await dispatch(saveEntity(json, data.auth.id.user.username));

      updateState(true, 'enable');
    } else {
      viewNotification(language.messages.msmErrorForm, 'error');
    }
  };
  //#endregion FUNCTIONS

  return (
    <Fragment>
    <SessionConfig ref={ref}/>
      <CrudPage
        top={<br />}
        formCol={{ md: 5, xl: 4 }}
        formTitle={language.messages.titleCEntityForm}
        form={
          <form autoComplete="off">
            <RequiredFieldsAlert />
            <SelectField
              row
              col={{ md: 12, xl: 8 }}
              label={language.messages.collectingEntity.country}
              loading={data.showLoadingCountry}
              isDisabled={data.id !== 0}
              name="country"
              options={data.countries}
              field={country}
              onChange={updateSelect}
              changeKey="country"
            />

            <TextField
              compact={false}
              label={language.messages.collectingEntity.name}
              name="name"
              field={data.name}
              onChange={onChange}
            />
            <Row>
              <TextField
                col={{ md: 6 }}
                label={language.messages.labelCode}
                name="code"
                field={data.code}
                onChange={onChange}
              />
              <TextField
                col={{ md: 6 }}
                label={
                  language.messages.collectingEntity.replication_time
                }
                name="replicationTime"
                maxLength="4"
                field={data.replicationTime}
                onChange={onChange}
              />
            </Row>
            <CrudButtons
              wrapped
              enable={data.enable}
              isNew={data.id === 0}
              onSave={saveData}
              onClear={cleaningForm}
              onReload={reSearch}
            />
          </form>
        }
        tableCol={{ md: 7, xl: 5 }}
        tableClassTitle=" text-uppercase text-capitalize"
        tableIcon="fa fa-list"
        tableTitle={language.messages.gridCEntitiesTitle}
        table={
          <CrudDataTable
            data={data}
            noHeader={es_vacio(country.label)}
            title={country.label}
            rows={data.cEntities}
            scrollHeight="600px"
            onSelect={handleSelectRow}
            paginationServer
            pending={pendingData}
            actions={contextActions}
            paginationTotalRows={data.totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
          />
        }
      />
    </Fragment>
  );
};
const App = () => (
  <ToastProvider>
    <CollectingEntity />
  </ToastProvider>
);
export default App;
